<template>
  <div>
    <h1 class="text-center">{{$t('user.register.register')}}</h1>
    <br />
    <div>
      <Input v-model="account" pre_icon="icon-yonghuming" :placeholder="$t('user.register.inputphone')" />
    </div>
    <!-- <div v-show="isPhone">
			<input hidden />
      <VerifyInput ref="verifyInput" pre_icon="icon-ziyuan" v-model="code" :placeholder="$t('user.register.inputcode')" @sendCode="sendCode" />
    </div> -->
    <div>
      <Input v-model="password" type="password" pre_icon="icon-mima" :placeholder="$t('user.register.inputpwd')" />
    </div>
    <div>
      <Input v-model="repassword" type="password" pre_icon="icon-mima" :placeholder="$t('user.register.inputpwd')" />
    </div>
    <div>
      <button class="btn btn-blue" @click="toRegitser"  v-loading="loading">{{$t('user.register.register-btn')}}</button>
    </div>
    <div class="between_line">
      <span class="btn" @click="toLogin"
        >{{$t('user.register.login')}}</span
      >
    </div>
  </div>
</template>
<script>
import { validatePass, is_email, is_Phone } from "@/utils/vaildate";
import { mapActions } from "vuex";
import {  Input } from "@/components";
export default {
  name:'register',
  data() {
    return {
      account: "",
      password: "",
      repassword: "",
      code: "",
      loading: false
    };
  
	},
	components: {
		Input
	},
  // computed: {
  //   isPhone() {
  //     return !is_email(this.account) && is_Phone(this.account);
  //   },
  // },
  methods: {
    ...mapActions("user", ["register", "sendSmsCode"]),
    vaild() {
      const { account, password,repassword } = this;
      if (!is_email(account) && !is_Phone(account)) {
        this.$tooltip.warning(this.$t('user.register.inputphone'));
        return false;
      }
      if (!password) {
        this.$tooltip.warning(this.$t('user.register.inputpwd'));
        return false;
      }
      if (!validatePass(password)) {
        this.$tooltip.warning(this.$t('user.register.correctpwd'));
        return false;
      }
      if(repassword !== password) {
        this.$tooltip.warning(this.$t('user.createwallet.create.tip-inconsistent'));
        return false;
      }
      return true
    },
    async toRegitser() {
      if(!this.vaild()) return
      try {
        this.loading = true
        const { account, password } = this;
        const params = {
          p1: account,
        };
        params.p2 = password;
        let eventName = "registerByEmail"
				await this.register({eventName, params});
				this.$tooltip.success(this.$t('user.register.success'));
        this.$router.push({ name: "login" });
        this.loading = false
      } catch (e) {
        this.$tooltip.error(e);
        this.loading = false
      }
    },
    async sendCode() {
      if (!this.isPhone){
				this.$tooltip.warning(this.$t('user.register.correctphone'));
				return
			}
      try {
        this.$refs.verifyInput.loading = true;
				await this.sendSmsCode({account:this.account});
        this.$refs.verifyInput.countDown();
        this.$refs.verifyInput.loading = false;
				this.$tooltip.success(this.$t('user.register.sendsuccess'));
      } catch (e) {
        this.$refs.verifyInput.loading = false;
				this.$tooltip.error(e);
      }
    },
    toLogin(){
      this.$router.push({name:'login'})
    }
  },
};
</script>
<style lang="sass" scoped>
.between_line
	text-align: left
	cursor: pointer
	margin-top: .6rem
</style>
